module.exports = __webpack_public_path__ + "static/savras-symbol-SCAG-e11e9a93827b180b03c4475348eea531.png";